export const unionDict = {
  "救赎之击-1": `给予敌人相当于自身攻击力3000 %的物理纯粹伤害。\n2回合期间，对敌人套用制动，使其无法行动。\n2回合期间，目标受到的伤害增加200%。`,
  "救赎之击-2": `给予敌人相当于自身攻击力3500 %的物理纯粹伤害。\n2回合期间，对敌人套用制动，使其无法行动。\n2回合期间，目标受到的伤害增加200%。`,
  "救赎之击-3": `给予敌人相当于自身攻击力4000 %的物理纯粹伤害。\n2回合期间，对敌人套用制动，使其无法行动。\n2回合期间，目标受到的伤害增加200%。`,
  "救赎之击-4": `给予敌人相当于自身攻击力4500 %的物理纯粹伤害。\n2回合期间，对敌人套用制动，使其无法行动。\n2回合期间，目标受到的伤害增加200%。`,
  "救赎之击-5": `给予敌人相当于自身攻击力5000 %的物理纯粹伤害。\n2回合期间，对敌人套用制动，使其无法行动。\n2回合期间，目标受到的伤害增加200%。`,
  "阿隆戴特的狂潮-1": `攻击敌人9次，\n每次攻击时，造成400 %攻击力的物理伤害`,
  "阿隆戴特的狂潮-2": `攻击敌人9次，\n每次攻击时，造成500 %攻击力的物理伤害`,
  "阿隆戴特的狂潮-3": `攻击敌人9次，\n每次攻击时，造成600 %攻击力的物理伤害`,
  "阿隆戴特的狂潮-4": `攻击敌人9次，\n每次攻击时，造成700 %攻击力的物理伤害`,
  "阿隆戴特的狂潮-5": `攻击敌人9次，\n每次攻击时，造成800 %攻击力的物理伤害`,
  "辉煌武技-1": `给予敌人相当于自身攻击力300 %的物理固定伤害。\n10回合期间，每回合造成400 %攻击力的物理伤害。`,
  "辉煌武技-2": `给予敌人相当于自身攻击力400 %的物理固定伤害。\n10回合期间，每回合造成450 %攻击力的物理伤害。`,
  "辉煌武技-3": `给予敌人相当于自身攻击力500 %的物理固定伤害。\n10回合期间，每回合造成500 %攻击力的物理伤害。`,
  "辉煌武技-4": `给予敌人相当于自身攻击力600 %的物理固定伤害。\n10回合期间，每回合造成550 %攻击力的物理伤害。`,
  "辉煌武技-5": `给予敌人相当于自身攻击力700 %的物理固定伤害。\n10回合期间，每回合造成600 %攻击力的物理伤害。`,
  "湖畔庇佑-1": `重置除了自身以外的我军技能冷却时间。\n我军的SP增加5点。`,
  "湖畔庇佑-2": `重置除了自身以外的我军技能冷却时间。\n我军的SP增加10点。`,
  "湖畔庇佑-3": `重置除了自身以外的我军技能冷却时间。\n我军的SP增加15点。`,
  "湖畔庇佑-4": `重置除了自身以外的我军技能冷却时间。\n我军的SP增加20点。`,
  "湖畔庇佑-5": `重置除了自身以外的我军技能冷却时间。\n我军的SP增加25点。`
};
